<template>
  
<FormKitLazyProvider>
<FormKit
    v-if="option?.option_id"
    :id="option?.option_id"
    :name="option?.option_id"
    type="select"
    :label="$t(option?.title) + (option?.required ? ' *' : '')"
    :placeholder="$t('Select an amount...')"
    :required="option?.required"
    :validation="option?.required ? `required` : ''"
    :options="options"
    :validation-messages="{
      required: $t('This is a required field.'),
    }"
    :disabled="isDisabled"
  />
</FormKitLazyProvider>

</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { MagentoGiftCardAmounts } from '~/app/types/magento'

const { n } = useI18n({ useScope: 'global' })

const { option } = defineProps({
  option: {
    type: Object<MagentoGiftCardAmounts>,
    required: true,
  },
})

const options = computed<array>(() =>
  option.amounts?.map((amount: MagentoGiftCardAmounts) => ({
    label: n(Number(amount.value), 'currency'),
    value: amount.uid,
  })) || [],
)

const isDisabled = ref(true)

onMounted(() => {
  // Enable the field when component is mounted
  isDisabled.value = false
})
</script>
